import { useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useMutation, useQueryClient } from 'react-query'

import { addIdentificationsLoginAPI } from 'api/identifications'
import { useIdentificationsStore } from 'store/identifications'

import {
  IdentificationsAddLoginParamsTypes,
} from 'types/identifications'

import { DATASTATUS } from 'constants/status'

export const useMemberIdentificationsAddLogin = ({
  modalClose,
}: {
  modalClose: () => void
}) => {
  const { traderId } = useParams()
  const memberTraderId = parseInt(String(traderId) || '0')

  const identificationsAddLoginModStatus = useIdentificationsStore(
    (state) => state.identificationsAddLoginModStatus
  )
  const identificationsAddLoginModStatusSet = useIdentificationsStore(
    (state) => state.identificationsAddLoginModStatusSet
  )

  const [identificationsAddLoginParams, identificationsAddLoginParamsSet] =
    useState<IdentificationsAddLoginParamsTypes>({
      traderId: memberTraderId,
      ident: '',
      password: '',
      identTypeId: 3,
    })

  const queryClient = useQueryClient()
  const { mutateAsync } = useMutation({
    mutationFn: addIdentificationsLoginAPI,
    mutationKey: 'addIdentificationsLogin',
    onMutate: (values) => {
      identificationsAddLoginModStatusSet('loading')
    },
    onSuccess: (getOffersIdentsResponse) => {
      queryClient.invalidateQueries({
        queryKey: ['useIdentifications'],
      })
      identificationsAddLoginModStatusSet('success')
    },
    onError: (error) => {
      identificationsAddLoginModStatusSet('fail')
    },
  })

  const handleAddLogin = useCallback(
    async (addLoginParams: IdentificationsAddLoginParamsTypes) => {
      try {
        const response = await mutateAsync({
          ...identificationsAddLoginParams,
          ...addLoginParams,
        })
        if (response.outcomeCode === DATASTATUS.outcomeCode) throw response
        toast.success('Member identification Add Login successful.')
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
          toast.error(message.outcomeUserMessage)
      } finally {
        // console.log('')
        // modalClose()
      }
      modalClose()
    },
    [mutateAsync]
  )

  return {
    memberIdentificationsAddLoginModStatus: identificationsAddLoginModStatus,
    memberIdentificationsAddLoginParams: identificationsAddLoginParams,
    memberHandleIdentificationsAddLogin: handleAddLogin,
  }
}
